/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Scope_Output5Inputs */

const en_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO blueprint`)
};

const ar_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخطط السيو`)
};

const bn_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO নকশা`)
};

const de_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO-Blaupause`)
};

const es_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano SEO`)
};

const fr_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan SEO`)
};

const pt_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano SEO`)
};

const zh_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO 蓝图`)
};

const tr_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO planı`)
};

const ru_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO-чертёж`)
};

const pl_svc_programmatic_seo_scope_output5 = /** @type {(inputs: Svc_Programmatic_Seo_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan SEO`)
};

/**
* | output |
* | --- |
* | "SEO blueprint" |
*
* @param {Svc_Programmatic_Seo_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_scope_output5 = /** @type {((inputs?: Svc_Programmatic_Seo_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "de") return de_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "es") return es_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_scope_output5(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_scope_output5(inputs)
	return en_svc_programmatic_seo_scope_output5(inputs)
});
export { svc_programmatic_seo_scope_output5 as "svc_programmatic-seo_SCOPE_output" }